import { InflateRequestMode } from '@sccs/types';
import { pipe } from 'valibot';
import {
  isMixedCampaignTileData,
  isMixedDlsTeaserResponse,
  isMixedOneSearchGraphQlResponse,
  isMixedSearchAlternativeResponse,
  isMixedT4Data,
  isVissVehicleTileDataQueryResponse,
  MixedResponseType,
} from '../types/GeneralTypes';
import {
  ConvertDlsSearchAlternativeToDlsTeaserTransformer,
  ConvertDlsSearchAlternativeToSimplePriceVehicleDataTransformer,
} from './dls/SearchAlternativeTransformer';
import { ConvertT4ToDlsTransformer } from './dls/T4PersonalizedToDlsTransformer';
import { ConvertDlsTeaserToVehicleDataTransformer } from './dls/TeaserTransformer';
import { ConvertOneSearchGraphQlToVehicleDataTransformer } from './onesearch/OneSearchGraphQlTransformer';
import { ConvertOneSearchGraphQlToSimplePriceVehicleDataTransformer } from './onesearch/simple-price/OneSearchGraphQlSimplePriceTeaserTransformer';
import {
  ConvertRawDataSimplePriceToVehicleDataTransformer,
  ConvertSimplePriceDlsToVehicleDataTransformer,
  ConvertSimplePriceOneSearchToVehicleDataTransformer,
  ConvertTCampaignTileDataToSimplePriceVehicleDataTransformer,
} from './simple-price/SimplePriceTransformer';
import { SchemaAny } from './VehicleTileDataSchema';
import { vissTileDataTransfomer } from './viss/TileDataTransformer';

export const getVehicleTileDataSchema = (result: MixedResponseType) => {
  if (isMixedDlsTeaserResponse(result)) {
    return ConvertDlsTeaserToVehicleDataTransformer;
  }

  if (isMixedSearchAlternativeResponse(result)) {
    if (result.mode === InflateRequestMode.SIMPLE_PRICE) {
      return pipe(
        SchemaAny,
        ConvertDlsSearchAlternativeToSimplePriceVehicleDataTransformer,
        ConvertSimplePriceDlsToVehicleDataTransformer,
      );
    } else {
      return pipe(
        SchemaAny,
        ConvertDlsSearchAlternativeToDlsTeaserTransformer,
        ConvertDlsTeaserToVehicleDataTransformer,
      );
    }
  }

  if (isMixedOneSearchGraphQlResponse(result)) {
    if (result.mode === InflateRequestMode.SIMPLE_PRICE) {
      return pipe(
        SchemaAny,
        ConvertOneSearchGraphQlToSimplePriceVehicleDataTransformer,
        ConvertSimplePriceOneSearchToVehicleDataTransformer,
      );
    } else {
      return ConvertOneSearchGraphQlToVehicleDataTransformer;
    }
  }

  if (isMixedT4Data(result)) {
    return pipe(SchemaAny, ConvertT4ToDlsTransformer, ConvertDlsTeaserToVehicleDataTransformer);
  }

  if (isMixedCampaignTileData(result)) {
    return pipe(
      SchemaAny,
      ConvertTCampaignTileDataToSimplePriceVehicleDataTransformer,
      ConvertRawDataSimplePriceToVehicleDataTransformer,
    );
  }

  if (isVissVehicleTileDataQueryResponse(result)) {
    return pipe(SchemaAny, vissTileDataTransfomer);
  }

  throw new Error('Unknown ResponseType');
};
